export const environment = {
  isLocalDev: false,
  federationManifest: 'federation.manifest.dev02.json',
  idp: {
    issuer: 'https://api-services.int.1placedessaisons.com/int/v1/oidc',
    clientId: '353d52ba-978e-4813-9147-6c181a50e3fe',
  },
  rmPermissionsCheckUrl: 'https://api-services.int.1placedessaisons.com/int/v3/permissions/check',
  dataRefsBusinessUnitsUrl: 'https://api-services.int.1placedessaisons.com/int/v1/businessUnits',
  requiredActionResourcesPermissions: {
    jade_admin: ['APP_JADE_MAIL_TO_TICKET'],
    'jade_api_mail-to-ticket_read_customer-service': [],
  },
};
